import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "popup-close" }, null, -1)
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "estate-card estate-card--popup" }
const _hoisted_5 = { class: "estate-card__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdImage = _resolveComponent("AdImage")!
  const _component_AdListItemPrice = _resolveComponent("AdListItemPrice")!
  const _component_AdListItemParams = _resolveComponent("AdListItemParams")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["estate-listing estate-listing--popup", { 'estate-listing--multiple': _ctx.ads.length > 1 }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ads, (item, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: _ctx.detailUrl + item.adFrontId,
          target: "_blank",
          class: "estate-listing__item"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AdImage, {
              file: item.images && item.images.length ? item.images[0] : null,
              adGuid: item.adGuid,
              watermark: false,
              estateType: item.estateType,
              estateSubType: item.estateSubType,
              class: "estate-card__photo",
              width: 610,
              height: 440
            }, null, 8, ["file", "adGuid", "estateType", "estateSubType"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AdListItemPrice, { ad: item }, null, 8, ["ad"]),
              _createVNode(_component_AdListItemParams, {
                ad: item,
                compact: true
              }, null, 8, ["ad"])
            ])
          ])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ], 2))
}